import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import SortedTablePlugin from "vue-sorted-table"
import Loading from '@/components/widgets/Loading.vue'
import UploadSlip from '../widget-upload-slip'
import Paginate from "@/components/widgets/pagination.vue";
import Seller from "@/components/widgets/seller";
import moment from 'moment'
import saleAmount from '@/util/sale-amount'

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})
export default {
  components: {
    DatePicker,
    Loading,
    Paginate,
    UploadSlip,
    Seller
  },
  data: function() {
    return {
      role: "",
      branch: "",
      loading: false,
      getPaid: {
        Id: null,
        state: false
      },
      busy: false,
      apiStatus: 'ไม่พบข้อมูล',
      totalItem: 0,
      status: null,
      paymentStatus: null,
      keyword_dynamic: null,
      seller_id: null,
      seller_name: '',
      isSellerEnabled: false,
      dynamicFilterOptions: [
        { value: 'dynamic_active', text: 'งานล่ำซำ - กำลังดำเนินการ' },
        { value: 'dynamic_ended', text: 'งานล่ำซำ - จบโครงการแล้ว' },
        { value: 'free_active', text: 'ส่งอิสระ - กำลังดำเนินการ' },
        { value: 'free_ended', text: 'ส่งอิสระ - จบโครงการแล้ว' },
        { value: 'non_dynamic', text: 'บิลปกติ (ไม่ใช่ล่ำซำ/ส่งอิสระ)' }
      ],
      doc: {
        start: null,
        end: null
      },
      duedate: {
        start: null,
        end: null
      },
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      keyword: '',
      fields: [
        { 
          key: 'document_no', 
          label: 'เลขที่ใบส่งสินค้า',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        // { 
        //   key: 'bill.bill_no', 
        //   label: 'เลขที่บิล',
        //   thClass: 'font-weight-bold text-xs-1/2',
        //   tdClass: 'td-top text-xs-1/2',
        //   sortable: true 
        // },
        {
          key: 'bill.bill_customer_name',
          label: 'ชื่อลูกค้า/โครงการ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        { 
          key: 'bill.bill_customer_shipping_address', 
          label: 'ที่อยู่',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true 
        },
        {
          key: 'creator_detail.name',
          label: 'ผู้จัดทำ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'bill_seller',
          label: 'ผู้ขาย',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'sale_price',
          label: 'ยอดขายสุทธิ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'total_price', 
          label: 'ยอดคงค้างสุทธิ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'bill.bill_no', 
          label: 'เอกสารอ้างอิงใบรับคำสั่งซื้อ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        // { 
        //   key: 'remark', 
        //   label: 'หมายเหตุ',
        //   thClass: 'font-weight-bold text-xs-1/2',
        //   tdClass: 'text-gray-400 td-top text-xs-1/2',
        //   class: 'text-left',
        //   sortable: true 
        // },
        { 
          key: 'status', 
          label: 'สถานะ', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'action', 
          label: '#', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          class: 'text-right' 
        }
      ],
      items: []
    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    // ยอดขาย — ใช้ helper กลาง @/util/sale-amount (คิดจาก nettotal−discount, ไม่ยุ่ง deposit)
    saleBase(item) { return saleAmount.saleBase(item) },
    saleSubtotal(item) { return saleAmount.saleSubtotal(item) },
    saleBeforeVat(item) { return saleAmount.saleBeforeVat(item) },
    saleVat(item) { return saleAmount.saleVat(item) },
    saleTotal(item) { return saleAmount.saleTotal(item) },
    // ยอดคงค้างสุทธิ — derive จาก bill_grand_total (ยอดคงค้างจริง) ให้ ก่อนVAT+VAT = ยอดคงค้าง เสมอ
    outstandingTotal(item) { return saleAmount.outstandingTotal(item) },
    outstandingBeforeVat(item) { return saleAmount.outstandingBeforeVat(item) },
    outstandingVat(item) { return saleAmount.outstandingVat(item) },
    depositBeforeVat(item) { return saleAmount.depositBeforeVat(item) },
    // tooltip รายละเอียดยอดขาย (ยอดรวม/ส่วนลด/ก่อน VAT/VAT) สำหรับ icon hover
    saleTooltip(item) {
      const fmt = (n) => parseFloat(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      const lines = [`ยอดรวม: ${fmt(saleAmount.saleSubtotal(item))} บาท`]
      if (parseFloat(item.bill_discount_amt || 0) > 0) lines.push(`ส่วนลด: -${fmt(item.bill_discount_amt)} บาท`)
      if (Number(item.bill_tax_type) !== 0) {
        lines.push(`ก่อน VAT: ${fmt(saleAmount.saleBeforeVat(item))} บาท`)
        lines.push(`VAT 7%: ${fmt(saleAmount.saleVat(item))} บาท`)
      }
      return lines.join('<br>')
    },
    // tooltip รายละเอียดยอดคงเหลือหลังหักมัดจำ สำหรับ icon hover
    outstandingTooltip(item) {
      const fmt = (n) => parseFloat(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      const lines = [`ยอดรวม: ${fmt(saleAmount.saleSubtotal(item))} บาท`]
      if (parseFloat(item.bill_discount_amt || 0) > 0) lines.push(`ส่วนลด: -${fmt(item.bill_discount_amt)} บาท`)
      lines.push(`หักมัดจำ: ${fmt(saleAmount.depositBeforeVat(item))} บาท`)
      if (Number(item.bill_tax_type) !== 0) {
        lines.push(`ยอดก่อน VAT: ${fmt(saleAmount.outstandingBeforeVat(item))} บาท`)
        lines.push(`VAT 7%: ${fmt(saleAmount.outstandingVat(item))} บาท`)
      }
      return lines.join('<br>')
    },
    billingNoteNos(item) {
      const nos = (item?.billing_note_items || [])
        .map(b => b?.billing_note?.document_no)
        .filter(Boolean)
      return nos.length ? 'ใบวางบิล: ' + nos.join(', ') : ''
    },
    canceledPayment(item) {
      const p = item?.last_canceled_payment?.payment
      if (!p || p.status !== 4) return null
      return p
    },
    canceledPaymentTooltip(item) {
      const p = this.canceledPayment(item)
      if (!p) return ''
      const parts = []
      if (p.document_no) parts.push('เลขที่: ' + p.document_no)
      if (p.cancel_reason) parts.push('เหตุผล: ' + p.cancel_reason)
      if (p.canceled_at) {
        parts.push('เมื่อ: ' + new Date(p.canceled_at).toLocaleDateString('th-TH', {
          year: 'numeric', month: 'short', day: 'numeric'
        }))
      }
      return parts.join(' | ')
    },
    paidLabel(item) {
      const nos = (item?.billing_note_items || [])
        .map(b => b?.billing_note?.document_no)
        .filter(Boolean)
      if (nos.length) {
        return 'ใบวางบิล: ' + nos.join(', ')
      }
      const paymentNo = item?.payment_item?.payment_document?.document_no
      return paymentNo ? 'ชำระรายบิล (' + paymentNo + ')' : 'ชำระรายบิล'
    },
    rowClass(item) {
      if (item && item.bill && item.bill.is_dynamic && item.bill.is_complete_deliver) return 'dynamic-row dynamic-ended-row'
      if (item && item.bill && item.bill.is_dynamic) return 'dynamic-row'
      if (item && item.bill && item.bill.is_free_delivery && item.bill.is_complete_deliver) return 'dynamic-ended-row'
      if (item && item.bill && item.bill.is_free_delivery) return 'free-delivery-row'
      return ''
    },
    getProjectName(item) {
      if (!item) return ''
      // project_name เก็บใน quotation_documents → trace: delivery.bill.quotation_document.project_name
      return item?.bill?.quotation_document?.project_name || ''
    },
    async getRole(){
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
      this.role = res.data.role
      this.branch = res.data.branch_id
    },
    onOpenSellerPopup() {
      this.isSellerEnabled = !this.isSellerEnabled
    },
    onSetSeller(e) {
      this.isSellerEnabled = false
      if (e && e.data) {
        this.seller_id = e.data.id
        this.seller_name = e.data.name
      }
    },
    onClearSeller() {
      this.seller_id = null
      this.seller_name = ''
    },
    handleGetPaidEvent(e) {
      this.getPaid.state = false
      if (e.status) {
        this.onInitData(this.currentPage)
      }
    },
    onUploadSlip(id) {
      this.getPaid.Id = id
      this.getPaid.state = !this.getPaid.state
    },
    ondeleted(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
          '<div class="d-flex flex-column">'+
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการจะยกเลิกบิลนี้หรือไม่?</span>'+
          '<span class="text-base text-left text-gray-500">หากคุณยืนยันแล้ว ข้อมูลจะไม่สามารถกู้คืนกลับมาได้?</span>'+
          '</div>'+
        '</div>',
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-rounded',
            closeButton: 'text-3xl swal2-custom-close',
            actions: 'justify-content-end',
            contant: 'd-flex flex-row justify-content-around px-2',
            title: 'd-none',
            confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
          },
          cancelButtonColor: '#dc4a38',
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: "ตกลง",
          showCancelButton: true,
          showCloseButton: true,
      }).then(async confirm => {
        if(confirm.value){
          this.loading = true
          this.onConfirmDelete(id)
        }
      })
    },
    async onConfirmDelete(id) {
      try {
        const param = {
          id: id
        }
        const result = await Vue.prototype.$axios.delete(
          `${Vue.prototype.$host}/api/v1/document/delivery/${id}`
        );
        setTimeout(() => {
          this.loading = false  
          if (result.status === 204) {            
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
                '<div class="d-flex flex-column">'+
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
                '<span class="text-base text-left text-gray-500">ยกเลิกบิลเรียบร้อยแล้ว</span>'+
                '</div>'+
              '</div>',
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  popup: 'swal2-custom-rounded',
                  closeButton: 'text-3xl swal2-custom-close',
                  actions: 'justify-content-end',
                  contant: 'd-flex flex-row justify-content-around px-2',
                  title: 'd-none',
                  confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                  cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
                },
                cancelButtonColor: '#dc4a38',
                cancelButtonText: 'ยกเลิก',
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                showCloseButton: true,
            }).then(async confirm => {
              if(confirm.value){
                this.onInitData(this.currentPage)
              }
            })          
          }
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    oncreate() {
      this.$router.push("/billing/create")
    },
    onInfo(id) {
      this.$emit('componentInfo', { 
        status: true,
        component: 'billing-info'
      })
    },
    onedit(uuid) {
      const routeData = this.$router.resolve({
        path: "/billing/create/" + uuid,
        query: { delivery: 'true' }
      });
      window.open(routeData.href, "_blank");
    },
    onallowedit(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการเปิดการแก้ไขใบรับคำสั่งซื้อนี้หรือไม่?</span>' +
          '<span class="text-base text-left text-gray-500">หากคุณยืนยันแล้ว จะเป็นการเปิดการแก้ไขบิลขายได้ 1 ครั้ง?</span>' +
          '</div>' +
          '</div>',
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          popup: 'swal2-custom-rounded',
          closeButton: 'text-3xl swal2-custom-close',
          actions: 'justify-content-end',
          contant: 'd-flex flex-row justify-content-around px-2',
          title: 'd-none',
          confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
        },
        cancelButtonColor: '#dc4a38',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: "ตกลง",
        showCancelButton: true,
        showCloseButton: true,
      }).then(async confirm => {
        if (confirm.value) {
          this.loading = true
          this.onConfirmEdit(id)
        }
      })
    },
    async onConfirmEdit(id) {
      try {
        const param = {
          id: id
        }
        this.loading = true
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/enableDeliveryEditing/${id}`
        );
        setTimeout(() => {
          this.loading = false
          if (result.status === 200) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
                '<div class="d-flex flex-column">' +
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
                '<span class="text-base text-left text-gray-500">เปิดให้แก้ไขเอกสารแล้ว</span>' +
                '</div>' +
                '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              cancelButtonColor: '#dc4a38',
              cancelButtonText: 'ยกเลิก',
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
            }).then(async confirm => {
              if (confirm.value) {
                this.onInitData(this.currentPage)
              }
            })
          }
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onApprove(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการยืนยันการชำระเงินหรือไม่?</span>' +
          '<span class="text-base text-left text-gray-500">หากคุณยืนยันแล้ว จะไม่สามารถแก้ไขได้?</span>' +
          '</div>' +
          '</div>',
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          popup: 'swal2-custom-rounded',
          closeButton: 'text-3xl swal2-custom-close',
          actions: 'justify-content-end',
          contant: 'd-flex flex-row justify-content-around px-2',
          title: 'd-none',
          confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
        },
        cancelButtonColor: '#dc4a38',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: "ตกลง",
        showCancelButton: true,
        showCloseButton: true,
      }).then(async confirm => {
        if (confirm.value) {
          this.loading = true
          this.onConfirmApprove(id)
        }
      })
    },
    async onConfirmApprove(id) {
      try {
        this.loading = true
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/approvePayment/${id}`
        );
        setTimeout(() => {
          this.loading = false
          if (result.status === 200) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
                '<div class="d-flex flex-column">' +
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
                '<span class="text-base text-left text-gray-500">ยืนยันสำเร็จ</span>' +
                '</div>' +
                '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              cancelButtonColor: '#dc4a38',
              cancelButtonText: 'ยกเลิก',
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
            }).then(async confirm => {
              if (confirm.value) {
                this.onInitData(this.currentPage)
              }
            })
          }
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onReject(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการปฏิเสธการชำระเงินหรือไม่?</span>' +
          '<span class="text-base text-left text-gray-500">หากคุณปฏิเสธแล้ว จะไม่สามารถแก้ไขได้?</span>' +
          '</div>' +
          '</div>',
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          popup: 'swal2-custom-rounded',
          closeButton: 'text-3xl swal2-custom-close',
          actions: 'justify-content-end',
          contant: 'd-flex flex-row justify-content-around px-2',
          title: 'd-none',
          confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
        },
        cancelButtonColor: '#dc4a38',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: "ตกลง",
        showCancelButton: true,
        showCloseButton: true,
      }).then(async confirm => {
        if (confirm.value) {
          this.loading = true
          this.onConfirmReject(id)
        }
      })
    },
    async onConfirmReject(id) {
      try {
        this.loading = true
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/rejectPayment/${id}`
        );
        setTimeout(() => {
          this.loading = false
          if (result.status === 200) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
                '<div class="d-flex flex-column">' +
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
                '<span class="text-base text-left text-gray-500">ยืนยันสำเร็จ</span>' +
                '</div>' +
                '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              cancelButtonColor: '#dc4a38',
              cancelButtonText: 'ยกเลิก',
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
            }).then(async confirm => {
              if (confirm.value) {
                this.onInitData(this.currentPage)
              }
            })
          }
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onInitData(currentPage) {
      this.currentPage = currentPage
      try {
        // this.items = []
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const page = currentPage ? currentPage : 1
        const url = `${Vue.prototype.$host}/api/v1/document/delivery?page=${page}&perPage=8&keyword=${this.keyword}&keyword_status=${this.status != null ? this.status+1 : ''}&started_at=${this.duedate.start ?  moment(this.duedate.start).format('YYYY-MM-DD') : ''}&ended_at=${this.duedate.end ?  moment(this.duedate.end).format('YYYY-MM-DD') : ''}&started_at2=${this.doc.start ?  moment(this.doc.start).format('YYYY-MM-DD') : ''}&ended_at2=${this.doc.end ?  moment(this.doc.end).format('YYYY-MM-DD') : ''}&payment_status=${this.paymentStatus !=null ? this.paymentStatus : ''}&keyword_dynamic=${this.keyword_dynamic != null ? this.keyword_dynamic : ''}&seller_id=${this.seller_id != null ? this.seller_id : ''}`
        const param = {
          keyword: this.keyword,
          url: url
        }
        const result = await this.$store.dispatch('Bills/getAll', param, { root: true })
        setTimeout(() => {
          this.busy = false
          this.apiStatus = 'ไม่พบข้อมูล'
          
          if (result) {
            this.currentData = result.data;
            this.items = result.data.data
            this.totalItem = result.data.total
          } else {
            this.items = []
            this.totalItem = 0
          }
        }, 500)
      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onPrintProductionHandler() {
      this.$emit('componentInfo', { 
        status: true,
        component: 'production'
      })
    },
    generateQRcode(uuid) {
      try {
        this.loading = true
        setTimeout(async () => {
          const result = await this.$axios.get(
            this.$host + "/api/v1/document/downloadDeliveryPDF/" + uuid,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              responseType: "blob"
            }
          )
          const blob = new Blob([result.data], {type: 'application/pdf'});
          const objectUrl = URL.createObjectURL(blob)
          window.open(objectUrl,'targetWindow',
          `toolbar=no,
          location=no,
          status=no,
          menubar=no,
          scrollbars=yes,
          resizable=yes,
          width=SomeSize,
          height=SomeSize`);

          // const link = document.createElement("a");
          // link.href = objectUrl;
          // this.pdfsrc = objectUrl
          // link.setAttribute(
          //   "download",
          //   `ใบเสนอราคา-${name}.pdf`
          // );
          // document.body.appendChild(link);
          // link.click();
    
          // URL.revokeObjectURL(objectUrl)
          this.loading = false
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    generateQRcodeWithOutPrice(uuid) {
      try {
        this.loading = true
        setTimeout(async () => {
          const result = await this.$axios.get(
            this.$host + "/api/v1/document/downloadDeliveryWithOutPricePDF/" + uuid,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              responseType: "blob"
            }
          )
          const blob = new Blob([result.data], {type: 'application/pdf'});
          const objectUrl = URL.createObjectURL(blob)
          window.open(objectUrl,'targetWindow',
          `toolbar=no,
          location=no,
          status=no,
          menubar=no,
          scrollbars=yes,
          resizable=yes,
          width=SomeSize,
          height=SomeSize`);

          // const link = document.createElement("a");
          // link.href = objectUrl;
          // this.pdfsrc = objectUrl
          // link.setAttribute(
          //   "download",
          //   `ใบเสนอราคา-${name}.pdf`
          // );
          // document.body.appendChild(link);
          // link.click();
    
          // URL.revokeObjectURL(objectUrl)
          this.loading = false
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    generateReceipt(uuid) {
      try {
        this.loading = true
        setTimeout(async () => {
          const result = await this.$axios.get(
            this.$host + "/api/v1/document/downloadDeliveryReceiptPDF/" + uuid,
            {
              headers: { "Content-Type": "multipart/form-data" },
              responseType: "blob"
            }
          )
          const blob = new Blob([result.data], { type: 'application/pdf' });
          const objectUrl = URL.createObjectURL(blob)
          window.open(objectUrl, 'targetWindow',
            `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=SomeSize,height=SomeSize`);
          this.loading = false
        }, 500)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler(error.response?.data?.message || 'เกิดข้อผิดพลาด')
      }
    },
    generateInvoice(delivery_uuid) {
      try {
        this.loading = true
        setTimeout(async () => {
          const result = await this.$axios.get(
            this.$host + "/api/v1/invoice-pdf/" + delivery_uuid,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              responseType: "blob"
            }
          )
          const blob = new Blob([result.data], {type: 'application/pdf'});
          const objectUrl = URL.createObjectURL(blob)
          window.open(objectUrl,'targetWindow',
          `toolbar=no,
          location=no,
          status=no,
          menubar=no,
          scrollbars=yes,
          resizable=yes,
          width=SomeSize,
          height=SomeSize`);

          // const link = document.createElement("a");
          // link.href = objectUrl;
          // this.pdfsrc = objectUrl
          // link.setAttribute(
          //   "download",
          //   `ใบเสนอราคา-${name}.pdf`
          // );
          // document.body.appendChild(link);
          // link.click();
    
          // URL.revokeObjectURL(objectUrl)
          this.loading = false
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onConvertToProduction(uuid){
      this.$router.push({ path: 'production/create', query: { q: uuid } })
    },
  },
  mounted() {
    this.getRole()
    this.onInitData(this.currentPage)
  }
}
